var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.27 7.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.65,7.42c-1.19,0-2.07-.31-2.65-1.43l1.04-.59c.4,.73,.84,.94,1.54,.94,.82,0,1.41-.41,1.41-1.18,0-.83-.72-1.17-1.89-1.17h-.42v-1.01h.38c1.15,0,1.72-.35,1.72-1,0-.54-.4-.91-1.16-.91-.56,0-1.03,.17-1.43,.74L.31,1.13C.92,.33,1.73,0,2.76,0c1.42,0,2.32,.7,2.32,1.86,0,.71-.43,1.31-1.3,1.59v.02c.98,.27,1.49,.89,1.49,1.8,0,1.38-1.11,2.15-2.62,2.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.90293ce9f8435bf4633b7fee1f95eecf.svg";
export { ForwardRef as ReactComponent };